import { defaultAgent, apiResponse } from "../helpers/web-agent";
import { toastError, toastSuccess } from "./toast";
import { GET_RATE_TYPE_LISTS, GET_RATE_TYPE_LISTS_REQUEST, GET_RATE_SCHEDULE_LISTS, GET_RATE_SCHEDULE_LISTS_REQUEST } from "../constants/action-types";
import { tokenExpired } from "./auth";
import { DELETE_RATE } from "../constants/messages";

export const getRateTypeListRequest = () => ({
  type: GET_RATE_TYPE_LISTS_REQUEST,
});

export const getRateTypeList = (payload, farmId) => ({
  type: GET_RATE_TYPE_LISTS,
  payload,
  farmId,
});
export const getRateSheduleListRequest = () => ({
  type: GET_RATE_SCHEDULE_LISTS_REQUEST,
});

export const getRateSheduleLists = (payload) => ({
  type: GET_RATE_SCHEDULE_LISTS,
  payload
});
export const getRateTypesList = () => (dispatch) => {
  dispatch(getRateTypeListRequest());
  defaultAgent
    .get("/api/rate/type/list")
    .then((res) => {
      const agentResult = apiResponse(res, []);
      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.message) {
        dispatch(getRateTypeList([]));
        dispatch(toastError(agentResult.message));
      } else if (agentResult.data)
        dispatch(getRateTypeList(agentResult.data));
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};

export const saveRateSchedules = (data) => (dispatch) => {
  defaultAgent
    .post("/api/rate/schedule/save", data)
    .then((res) => {
      const agentResult = apiResponse(res, {});
      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.data) {
        dispatch(toastSuccess(agentResult.message));
      } else if (agentResult.message) {
        if (agentResult.status === "error") {
          dispatch(toastError(agentResult.message));
        } else {
          dispatch(toastSuccess(agentResult.message));
        }
      }
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};

export const getRateScheduleLists = (farmId) => (dispatch) => {
  dispatch(getRateSheduleListRequest());
  defaultAgent
    .get("/api/rate/schedule/list", { farm_uuid: farmId })
    .then((res) => {
      const agentResult = apiResponse(res, []);
      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.message) {
        dispatch(getRateSheduleLists([]));
        dispatch(toastError(agentResult.message));
      } else if (agentResult.data)
        dispatch(getRateSheduleLists(agentResult.data));
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};

export const deleteRateScheduls = (params, cb) => dispatch => {
  defaultAgent.put(`api/rate/schedule/delete`, params)
      .then(res => {
          const agentResult = apiResponse(res);
          if (agentResult.isUnauthorized) {
              dispatch(toastError(agentResult.message));
              dispatch(tokenExpired());
          } else if (agentResult.code === DELETE_RATE.code) {
              dispatch(toastSuccess(agentResult.message));
              if (cb) cb(true);
          } else if (agentResult.message) {
              dispatch(toastError(agentResult.message));
              if (cb) cb(false);
          }
      }).catch(ex => {
          dispatch(toastError(ex.message));
          if (cb) cb(false);
      });
}